var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.98,14.54c-1.79,0-3.24-1.45-3.24-3.24s1.45-3.24,3.24-3.24s3.24,1.45,3.24,3.24S6.76,14.54,4.98,14.54z  M4.98,8.56c-1.51,0-2.74,1.23-2.74,2.74s1.23,2.74,2.74,2.74s2.74-1.23,2.74-2.74S6.49,8.56,4.98,8.56z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.12,9.14 6.68,8.9 10.76,1.38 14.13,3.06 13.9,3.5 10.97,2.04  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch01);
export default __webpack_public_path__ + "static/media/Switch-01.5643c632380a552c30250db6ecd8bea4.svg";
export { ForwardRef as ReactComponent };